import { createFileRoute } from '@tanstack/react-router';
import { GitBranch } from 'lucide-react';
import { ComingSoonPage } from '@/components/sysadmin/coming-soon';

export const Route = createFileRoute('/sysadmin/governance/approvals')({
  component: () => (
    <ComingSoonPage
      icon={GitBranch}
      title="Approval Policies"
      specRef="§3.5 [v2]"
      wave="Phase 6"
      description="Default tiered approval policies per action class. Single-confirm / supervisor / 2-person rule defaults, applied platform-wide unless tenant overrides. PR-A ships v1 with Guardrails / Compliance / Classification only; Approvals is scaffolded for Phase 6."
      bullets={[
        'Single-confirm — typed-confirm dialog (default for low-risk reversibles)',
        'Supervisor — second sysadmin signs',
        '2-person rule — two distinct sysadmins, separated in time, ITAR-grade',
        'Per-action-class assignment (e.g., key rotation = 2-person)',
        'Hooks into platform_audit_logs for the second-approver record',
      ]}
    />
  ),
});
